export default function StatCard({
  title,
  value,
}: {
  title: string;
  value: string;
}) {
  return (
    <div className="rounded-2xl bg-[#181b1f] border border-white/10 p-4 sm:p-5">

      <p className="text-[10px] sm:text-xs text-gray-500">
        {title}
      </p>

      <p className="text-xl sm:text-2xl mt-2">
        {value}
      </p>

    </div>
  );
}